import hrms76xLabels from 'assets/labels/hrms76x'
import faker from 'faker'

export const mocker = {
  labels () {
    return {
      labels: hrms76xLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        desc_codpos: faker.name.title(),
        numlvl: faker.random.number().toString().substr(0, 2),
        desc_codcours: 'External training',
        desc_codtparg: 'External',
        codplan: faker.random.arrayElement().toUpperCase(),
        staappr: '',
        desc_staappr: mockStatus[staappr]
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms76x/mocker.js